module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/solicitar-dir-vlan/solicitar-dir-vlan.component.css
// module id = ./src/app/solicitar-dir-vlan/solicitar-dir-vlan.component.css
// module chunks = main